import { Drawer, message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { createMaintenance, fetchAllMaintenances, updateMaintenance } from "../../../core/data/redux/asset/assetMaintenanceAction/assetMaintenanceAction";
import { fetchAllAssets, fetchAssetDetailsByAssetId } from "../../../core/data/redux/asset/asset/assetActions";
import { fetchAllClients } from "../../../core/data/redux/projects/client/clientAction";
import { filterByStatus } from "../../../core/utils/filterActiveData";
import { getEmployeeByUserId } from "../../../core/data/redux/employee/employeeAction";


const AssetMaintenanceModal: React.FC<any> = ({
    modalType,
    isModalVisible,
    handleCancel,
    employeeId,
    setTableKey,
    maintenanceId,
    selectedRowData,
}) => {
    // console.log("selectedRowData", selectedRowData)
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { maintenances, loadingStates } = useSelector((state: any) => state.asset.assetMaintenance);
    const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
    const { assets } = useSelector((state: any) => state.asset.newAsset);
    const activeAssets = filterByStatus(assets, 'active', 'status');
    const { assetDetails } = useSelector((state: any) => state.asset.newAsset);
    const usedSerialNumbers = maintenances.map((maintenance: any) => maintenance.asset_details_id);    
    const availableSerialNumbers = assetDetails.filter((serial: any) => {
        if (modalType === 'edit' && selectedRowData?.asset_details_id === serial.asset_details_id) {
            return true;
        }
        return !usedSerialNumbers.includes(serial.asset_details_id);
    });

    const { clients } = useSelector((state: any) => state.project.clients);
    const vendor: any = clients ? clients.filter((client: any) => client.client_or_vendor === 1) : [];
    const [errors, setErrors] = useState<any>({});
    const [maintenanceData, setMaintenanceData] = useState({
        asset_id: "",
        asset_details_id: "",
        maintenance_type: "service",
        maintenance_date: "",
        next_due_date: "",
        cost: "",
        vendor: "",
        description: "",
        status: "scheduled",
    });

    useEffect(() => {
        if (!maintenances.length) {
            dispatch(fetchAllMaintenances());
        }
        if (!assets.length) {
            dispatch(fetchAllAssets());
        }
        if (maintenanceData?.asset_id) {
            dispatch(fetchAssetDetailsByAssetId({ assetId: maintenanceData?.asset_id }));
        }
        if (!clients.length) {
            dispatch(fetchAllClients())
        }

    }, [maintenances.length, dispatch, modalType, assets.length, maintenanceData?.asset_id, clients.length]);

    useEffect(() => {
        if (isModalVisible && modalType === "edit" && maintenanceId && selectedRowData){
            setMaintenanceData({
                asset_id: selectedRowData.asset_id || "",
                asset_details_id: selectedRowData.asset_details_id || "",
                maintenance_type: selectedRowData.maintenance_type || "service",
                maintenance_date: selectedRowData.maintenance_date ? selectedRowData.maintenance_date.slice(0, 10) : "",
                next_due_date: selectedRowData.next_due_date ? selectedRowData.next_due_date.slice(0, 10) : "",
                cost: selectedRowData.cost || "",
                vendor: selectedRowData.vendor || "",
                description: selectedRowData.description || "",
                status: selectedRowData.status || "scheduled"
            });
        }
        setErrors({});
    }, [selectedRowData, maintenanceId, modalType,isModalVisible]);

    const handleInputChange = (e: any, field: string) => {
        const { value } = e.target;
        setMaintenanceData((prevState: any) => ({
            ...prevState,
            [field]: value,
        }));
    };

    const resetForm = () => {
        setMaintenanceData({
            asset_id: "",
            asset_details_id: "",
            maintenance_type: "service",
            maintenance_date: "",
            next_due_date: "",
            cost: "",
            vendor: "",
            description: "",
            status: "scheduled",
        });
        setErrors({});
    };

    const validateForm = () => {
        let formIsValid = true;
        let newErrors: any = {
            asset_id: "",
            asset_details_id: "",
            maintenance_date: "",
            cost: "",
            vendor: "",
            description: "",
        };

        if (!maintenanceData.asset_id) {
            formIsValid = false;
            newErrors.asset_id = "Please select an asset.";
        }

        if (!maintenanceData.asset_details_id) {
            formIsValid = false;
            newErrors.asset_details_id = "Please select asset serial number.";
        }

        if (!maintenanceData.maintenance_date) {
            formIsValid = false;
            newErrors.maintenance_date = "Maintenance date is required.";
        }

        if (!maintenanceData.cost || isNaN(Number(maintenanceData.cost)) || Number(maintenanceData.cost) <= 0) {
            formIsValid = false;
            newErrors.cost = "Cost must be greater than 0.";
        }

        if (!maintenanceData.vendor.trim()) {
            formIsValid = false;
            newErrors.vendor = "Vendor is required.";
        }
        if (!maintenanceData.next_due_date.trim()) {
            formIsValid = false;
            newErrors.next_due_date = "next due date is required.";
        }
        if (!maintenanceData.maintenance_type) {
            formIsValid = false;
            newErrors.maintenance_type = "Please select maintenance type.";
        }
        if (!maintenanceData.status) {
            formIsValid = false;
            newErrors.status = "Please select status.";
        }
        setErrors(newErrors);
        return formIsValid;
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        const maintenancePayload = {
            asset_id: Number(maintenanceData.asset_id),
            asset_details_id: Number(maintenanceData.asset_details_id),
            maintenance_type: maintenanceData.maintenance_type,
            maintenance_date: maintenanceData.maintenance_date,
            next_due_date: maintenanceData.next_due_date,
            cost: parseFloat(maintenanceData.cost),
            vendor: maintenanceData.vendor,
            description: maintenanceData.description,
            status: maintenanceData.status,
            created_by: user?.UserId,
            modified_by: user?.UserId,
            EmployeeId: employeeId
        };
        if (modalType === "create") {
            const result = await dispatch(createMaintenance(maintenancePayload));
            if (result.meta.requestStatus === "fulfilled") {
                message.success("Asset maintenance created successfully");
                resetForm();
                await dispatch(fetchAllMaintenances());
                if (typeof setTableKey === "function") {
                    setTableKey((prevKey: any) => prevKey + 1);
                }
            } else if (result.meta.requestStatus === "rejected") {
                alert(result.payload.error);
            }
        } else if (modalType === "edit" && maintenanceId) {
            const result = await dispatch(updateMaintenance({ id: maintenanceId, data: maintenancePayload }));
            if (result.meta.requestStatus === "fulfilled") {
                message.success("Asset maintenance updated successfully");
                await dispatch(fetchAllMaintenances());
                if (typeof setTableKey === "function") {
                    setTableKey((prevKey: any) => prevKey + 1);
                }
                resetForm();
            } else if (result.meta.requestStatus === "rejected") {
                const errorPayload = result.payload as { error: string };
                message.error(errorPayload?.error || 'Delete failed');
            }
        }
        handleCancel();
    };

    return (
        <Drawer
            title={modalType === "edit" ? "Edit Asset Maintenance" : "Add Asset Maintenance"}
            placement="right"
            width={650}
            onClose={() => {
                handleCancel();
                resetForm();
            }}
            visible={isModalVisible}
            style={{ marginTop: 50, paddingBottom: 50 }}
        >
            <form>
                <div className="modal-body pb-0">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Asset <span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    value={maintenanceData.asset_id}
                                    onChange={(e) => handleInputChange(e, "asset_id")}
                                >
                                    <option value="">Select Asset</option>
                                    {activeAssets.map((asset: any) => (
                                        <option key={asset.assetId} value={asset.assetId}>
                                            {asset.AssetName}
                                        </option>
                                    ))}
                                </select>
                                {errors.asset_id && <div style={{ color: "red" }}>{errors.asset_id}</div>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Asset Serial Number <span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    value={maintenanceData.asset_details_id}
                                    onChange={(e) => handleInputChange(e, "asset_details_id")}
                                >
                                    <option value="">Select Serial Number</option>
                                    {availableSerialNumbers.map((serial: any) => (
                                        <option key={serial.asset_details_id} value={serial.asset_details_id}>
                                            {serial.SerialNumber}
                                        </option>
                                    ))}
                                </select>
                                {errors.asset_details_id && <div style={{ color: "red" }}>{errors.asset_details_id}</div>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Maintenance Date <span className="text-danger">*</span></label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={maintenanceData.maintenance_date}
                                    onChange={(e) => handleInputChange(e, "maintenance_date")}
                                />
                                {errors.maintenance_date && <div style={{ color: "red" }}>{errors.maintenance_date}</div>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Next Due Date <span className="text-danger">*</span></label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={maintenanceData.next_due_date}
                                    onChange={(e) => handleInputChange(e, "next_due_date")}
                                />
                                {errors.next_due_date && <div style={{ color: "red" }}>{errors.next_due_date}</div>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Cost <span className="text-danger">*</span></label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={maintenanceData.cost}
                                    onChange={(e) => handleInputChange(e, "cost")}
                                />
                                {errors.cost && <div style={{ color: "red" }}>{errors.cost}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Vendor<span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    value={maintenanceData.vendor}
                                    onChange={(e) => handleInputChange(e, "vendor")}
                                >
                                    <option value="">Select Vendor</option>
                                    {[...vendor]
                                    .sort((a: any, b: any) => a.first_name.localeCompare(b.first_name))
                                    .map((v: any) => (
                                        <option key={v.client_id} value={v.client_id}>
                                            {v.first_name}{" "}{v.last_nama}
                                        </option>
                                    ))}
                                </select>
                                {errors.vendor && <div style={{ color: "red" }}>{errors.vendor}</div>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Maintenance Type <span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    value={maintenanceData.maintenance_type}
                                    onChange={(e) => handleInputChange(e, "maintenance_type")}
                                >
                                    <option value="service">Service</option>
                                    <option value="repair">Repair</option>
                                    <option value="inspection">Inspection</option>
                                    <option value="upgrade">Upgrade</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Status <span className="text-danger">*</span></label>
                                <select
                                    className="form-control"
                                    value={maintenanceData.status}
                                    onChange={(e) => handleInputChange(e, "status")}
                                >
                                    <option value="scheduled">Scheduled</option>
                                    <option value="in_progress">In Progress</option>
                                    <option value="completed">Completed</option>
                                    <option value="cancelled">Cancelled</option>
                                    <option value="paid">Paid</option>
                                    <option value="unpaid">Unpaid</option>
                                </select>
                                {errors.status && <div style={{ color: "red" }}>{errors.status}</div>}
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Description </label>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    value={maintenanceData.description}
                                    onChange={(e) => handleInputChange(e, "description")}
                                />
                                {errors.description && <div style={{ color: "red" }}>{errors.description}</div>}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-light me-2"
                        onClick={() => {
                            handleCancel();
                            resetForm();
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                        disabled={isLoading}

                    >
                        {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
                        {modalType === "edit" ? "Update Maintenance" : "Submit Maintenance"}
                    </button>
                </div>
            </form>
        </Drawer>
    );
};

export default AssetMaintenanceModal;
